/* Copyright IBM Corp. 2017 */
import { ApplicationConfig } from './application.config';

export const EMPTY_APPLICATION_CONFIG: ApplicationConfig = {
  id: null,
  name: null,
  classification: 'content',
  kind: [],
  type: null,
  typeId: null,
  elements: {}
};
